import { Compass } from "lucide-react";
import { Link } from "react-router";

import { Button } from "@/ui/Button";
import { EmptyState } from "@/ui/EmptyState";

/** Any address the app does not know. */
export function NotFoundScreen() {
  return (
    <main className="mx-auto w-full max-w-xl px-4 py-16">
      <EmptyState
        icon={<Compass />}
        title="This page does not exist"
        action={
          <Button asChild variant="primary">
            <Link to="/sets">Go to your sets</Link>
          </Button>
        }
      >
        The link may be old, or mistyped.
      </EmptyState>
    </main>
  );
}
